// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"20":"d4f3f9c0","668":"8cb3fa18","856":"b7f91d23"}[chunkId] + ".chunk.css";
};